import '../assets/styles/Partners.css';

function Partners() {
  const partners = [
    {
      name: 'Global Shipping Co.',
      logo: '/assets/images/partner1.png', // Placeholder image
      description: 'Leading provider of ocean freight solutions worldwide.',
     
    },
    {
      name: 'AirSwift Logistics',
      logo: '/assets/images/partner2.png', // Placeholder image
      description: 'Specialized in rapid air freight services.',
     
    },
    {
      name: 'Secure Storage Inc.',
      logo: '/assets/images/partner3.png', // Placeholder image
      description: 'Trusted warehousing and storage solutions.',
     
    },
    {
      name: 'Express Cargo Ltd.',
      logo: '/assets/images/partner4.png', // Placeholder image
      description: 'Experts in express cargo delivery.',
     
    },
  ];

  return (
    <section className="partners-section py-5 bg-light">
      <div className="container">
        <h2 className="about-title fw-bold mb-4 text-center">Our Trusted Partners</h2>
        <p className="main-description text-center mb-5">
          We collaborate with industry leaders to deliver exceptional logistics solutions worldwide.
        </p>
        <div className="row row-cols-1 row-cols-md-4 g-4">
          {partners.map((partner, index) => (
            <div key={index} className="col">
              <div className="partner-card h-100 text-center">
                <img
                  src={partner.logo}
                  className="partner-logo"
                  alt={partner.name}
                  style={{ height: '100px', objectFit: 'contain' }}
                />
                <div className="card-body">
                  <h5 className="vision-mission-title">{partner.name}</h5>
                  <p className="vision-mission-text">{partner.description}</p>
                
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Partners;